import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getFAQ } from './mapper';

export const faqQueryKey = createQueryKeys('faq', {
  list: {
    queryFn: async () => {
      const data = await getFAQ();
      return data;
    },
    queryKey: null,
  },
});

export type FaqQueryKey = inferQueryKeys<typeof faqQueryKey>;
